import AltLoginsForm from './AltLoginsForm';

export default AltLoginsForm;
